import { lazy } from 'react';

const CalendarDiscovery = lazy(() =>
  import(/* webpackChunkName: "discovery-calendar" */ './CalendarDiscovery')
);
const Discovery = lazy(() => import(/* webpackChunkName: "discovery" */ './DiscoveryIndex'));
const DiscoveryStock = lazy(() =>
  import(/* webpackChunkName: "discovery-stock" */ './DiscoveryStock')
);
const DiscoveryMutualFund = lazy(() =>
  import(/* webpackChunkName: "discovery-mf" */ './DiscoveryMutualFund')
);
const EIPODetail = lazy(() =>
  import(/* webpackChunkName: "discovery-eipo-detail" */ './DiscoveryStock/EIPO/')
);
const HighlightDetail = lazy(() =>
  import(/* webpackChunkName: "discovery-highlight-detail" */ './DiscoveryStock/Highlight/Detail')
);

export {
  CalendarDiscovery,
  Discovery,
  DiscoveryMutualFund,
  DiscoveryStock,
  EIPODetail,
  HighlightDetail,
};
